import { ActivatedRoute } from '@angular/router';
import { NewsService } from './../../../providers/noticias.service';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

export class Noticia {
  data = '';
  id = '';
  texto = '';
  thumb = '';
  titulo = '';
}

@Component({
  selector: 'app-interna',
  templateUrl: './interna.component.html',
  styleUrls: ['./interna.component.scss']
})
export class InternaComponent implements OnInit {

  sub: Subscription;
  id: number;
  noticia = new Noticia();

  constructor(
    private noticiaService: NewsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.sub = this.route.params.subscribe(data => {

      this.id = data['id'];

      this.noticiaService.getDetailNews(this.id)
      .subscribe(res => {
        this.noticia = res[0];
      });

    });

  }

}
